import clsx from 'clsx';
import React, { forwardRef, useState, useCallback, useEffect } from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import styles, { dialog as dialogClass, titleContainer as titleContainerClass, overlayContainer as overlayClass } from './dialog.module.css';
import { ClampText } from '../clamp-text';
import { Separator } from "../separator";
import { Icon } from "../icon";
const DialogRoot = DialogPrimitive.Root;
const DialogTrigger = DialogPrimitive.Trigger;
const DialogContent = DialogPrimitive.Content;
const DialogTitle = DialogPrimitive.Title;
const DialogClose = DialogPrimitive.Close;
const DialogPortal = DialogPrimitive.Portal;
const Title = ({ title, withSeparator }) => {
    return (React.createElement(DialogTitle, { asChild: true },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: titleContainerClass, "data-title": !!title, "data-separator": withSeparator },
                title && React.createElement(ClampText, { rows: 1 }, title),
                React.createElement(DialogClose, { asChild: true },
                    React.createElement(Icon, { name: "close/24", className: styles.icon }))),
            withSeparator && React.createElement(Separator, null))));
};
export const Dialog = forwardRef(({ activator, title, textAlign = 'start', className, withOverlay = true, withSeparator = true, children, onOpenChange, open = false, ...props }, forwardedRef) => {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        if (open !== visible) {
            setVisible(open);
        }
    }, [open]);
    const handleOpen = useCallback(() => (openStatus) => {
        setVisible(open);
        if (onOpenChange) {
            onOpenChange(openStatus);
        }
    }, [onOpenChange]);
    const cssVars = {
        textAlign
    };
    return (React.createElement(DialogRoot, { onOpenChange: handleOpen(), open: visible },
        React.createElement(DialogTrigger, { asChild: true }, activator),
        React.createElement(DialogPortal, null,
            withOverlay && (React.createElement(DialogPrimitive.Overlay, { asChild: true },
                React.createElement("div", { className: overlayClass }))),
            React.createElement(DialogContent, { asChild: true },
                React.createElement("div", { ref: forwardedRef, className: clsx(dialogClass, className), style: { ...cssVars }, "data-title": Boolean(title), "data-visible": visible, ...props },
                    React.createElement(Title, { withSeparator: withSeparator, title: title }),
                    children)))));
});
